import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap, finalize } from "rxjs/operators";
import { ProgressBarService } from "../progress-bar/progress-bar.service";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  constructor(private progressBarService: ProgressBarService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    this.activeRequests++;
    this.progressBarService.setLoading(true);

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<unknown>) => {
          if (event instanceof HttpResponse) {
            // Request completed successfully
          }
        },
        () => {
          // Request failed
        },
      ),
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this.progressBarService.setLoading(false);
        }
      }),
    );
  }
}
